var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"width":"6","height":"19","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M.923 1.11l3.904 8.494L.923 18.11","stroke":"#1C3348","stroke-width":"2","fill":"none","fill-rule":"evenodd","opacity":".4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }